export const CLEAR_RENDER_API_POLL_TIMEOUT = 'CLEAR_RENDER_API_POLL_TIMEOUT';
export const SET_DESIGN_TO_PLAYGROUND = 'SET_DESIGN_TO_PLAYGROUND';
export const SET_DESIGN_TO_CAMERA = 'SET_DESIGN_TO_CAMERA';
export const SET_RENDER_API_POLL_TIMEOUT_ID = 'SET_RENDER_API_POLL_TIMEOUT_ID';
export const UPDATE_SWAP_END_RESULTS = 'UPDATE_SWAP_END_RESULTS';
export const UPDATE_SHOW_SWAP_NOTIFICATION = 'UPDATE_SHOW_SWAP_NOTIFICATION';
export const UPDATE_SHOW_SWAP_MODAL_STATUS = 'UPDATE_SHOW_SWAP_MODAL_STATUS';
export const UPDATE_SWAP_STATUS = 'UPDATE_SWAP_STATUS';
